import { createContext } from 'react'

type DeviceIdContextValue = {
  deviceId?: string
  setDeviceId: (value: string) => void
}

export const DeviceIdContext = createContext<DeviceIdContextValue>({
  deviceId: undefined,
  setDeviceId: () => {},
})
